import { useState, useEffect, useRef } from "react";
import { Overlay, OverlayTrigger, Popover, Button, Form, Modal } from 'react-bootstrap';
import { useQuiz } from "../QuizContext";

/* room2 거실 */

function Room2(){

  const { setTabletSolved } = useQuiz();
  const [resultModalShow, setResultModalShow] = useState(false);
  const [resultMessage, setResultMessage] = useState('');
  const [password, setPassword] = useState('');
  const [showHint, setShowHint] = useState(false);

    const [showSofaPopover, setShowSofaPopover] = useState(false);
    const [SofaPopoverText, setSofaPopoverText] = useState('');
    const SofaRef = useRef(null);

      const handleSofaClick = () => {
      setSofaPopoverText("먼지가 앉아있다");
      setShowSofaPopover(true);

      setTimeout(() => setShowSofaPopover(false), 2000);
      };

  const handleSubmit = (e) => {
  e.preventDefault();

  if (password === '알파우리') {
    setTabletSolved(true);  // ✅ 전역 상태 업데이트
    setResultMessage('길드장님과 어떤 남자의 사진이 띄워져있다. \n처음 보는 얼굴인데...');
    setResultModalShow(true);
  } else if (password === '창호기려') {
    setResultMessage('?');
    setResultModalShow(true);
  } else {
    setResultMessage('비밀번호를 잘못 입력했습니다');
    setResultModalShow(true);
  }
};

  const popover = (
    <Popover id="popover-password">
      <Popover.Header as="h3">비밀번호</Popover.Header>
      <Popover.Body>
        <Form onSubmit={handleSubmit}>
          {/* 입력창 */}
          <Form.Control
            type="text"
            placeholder="_ _ _ _"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="mb-2"
          />

          {/* 버튼 그룹 */}
          <div className="d-flex gap-2 mb-2 justify-content-end">
            <Button
              variant="outline-secondary"
              size="sm"
              onClick={() => setShowHint(!showHint)}
            >
              HINT
            </Button>
            <Button type="submit" variant="primary" size="sm">
              확인
            </Button>
          </div>

          {/* 힌트 표시 */}
          {showHint && (
            <div className="mt-2 text-muted" style={{ fontSize: '0.9rem' }}>
              97+108+112+104+97+117+114+105<br />
              p.s. 내가 뭘 보고 웃는지 알고 싶다며. 풀고 싶으면 한 번 풀어봐.
            </div>
          )}
        </Form>
      </Popover.Body>
    </Popover>
  );

  useEffect(() => {
  const popovers = document.querySelectorAll('.popover');
  popovers.forEach(pop => {
    if (resultModalShow) {
      pop.classList.add('blurred');
    } else {
      pop.classList.remove('blurred');
    }
  });
}, [resultModalShow]);


    return(

      <>
        <Modal
        show={resultModalShow}
        onHide={() => setResultModalShow(false)}
        centered
        style={{ zIndex: 2000 }}
      >
      <Modal.Header
        closeButton
        className="small-header"
        style={{ borderBottom: 'none' }}  // 👈 회색선 제거
      />        
      <Modal.Body className="text-center">{resultMessage}</Modal.Body>
      <Modal.Footer
        className="small-footer"
        style={{ borderTop: 'none' }}  // 👈 회색선 제거
      >          
      <Button variant="outline-primary" onClick={() => setResultModalShow(false)}>
            확인
          </Button>
        </Modal.Footer>
      </Modal>
      
        <div
        className="d-flex justify-content-center align-content-center flex-wrap" 
        style={{height: 'calc(100vh - 200px)',
        display: 'flex',
        //justifyContent: 'center',
        alignItems: 'end',
        gap: '5vw',
        marginTop: '-5vh',
        padding: '0 2vw',
         }}>
          <OverlayTrigger trigger="click" placement="top" overlay={popover} rootClose>
      <Button variant="secondary"
        style={{
          backgroundColor:'#dee2e6',
          backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
          backgroundSize: '5px 5px',
          }}
      >태블릿</Button>
    </OverlayTrigger>
        

          <button
          ref={SofaRef}
          type="button"
          className="btn btn-secondary"
          onClick={handleSofaClick}
          style={{
            width: '30vw',
            height: '20vh',
            marginTop: '-5vh',
            backgroundColor:'#dee2e6',
            backgroundImage: 'radial-gradient(lightgrey 2px, transparent 10px)',
            backgroundSize: '5px 5px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          >소파</button>

             <Overlay target={SofaRef.current} show={showSofaPopover} placement="top">
              {(props) => (
                <Popover {...props}>
                  <Popover.Body>{SofaPopoverText}</Popover.Body>
                </Popover>
              )}
            </Overlay>


          </div>
        
        
          </>
       );
       
}

export default Room2;

